import { render, staticRenderFns } from "./carcome-time.vue?vue&type=template&id=315f5122&scoped=true&"
import script from "./carcome-time.vue?vue&type=script&lang=js&"
export * from "./carcome-time.vue?vue&type=script&lang=js&"
import style0 from "./carcome-time.vue?vue&type=style&index=0&id=315f5122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315f5122",
  null
  
)

export default component.exports